




import { Component, Prop, Vue } from 'vue-property-decorator';

import AnagraficaList from '@/components/AnagraficaList.vue';

@Component({
  components: {
    AnagraficaList
  }
})
export default class Home extends Vue {}
